import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import React from "react";

export const MonthAndYearDropdown = ({ data,
    handleChange,
    shownDropdownValue,
}) => {
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        dispatch(isDropdownOpenFlag(open));
    }, [open]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const onElementClicked = (item) => {
        handleChange(item.id);
        setOpen((prevOpen) => !prevOpen);
    };

    const onButton = () => {
        setOpen((prevOpen) => !prevOpen);

    };

    return (
        <>
            <div ref={dropdownRef}>
                {/* <div style={{ flex: 1, color: "white" }}> */}
                    <div className="wrapper-monthandyear">
                        <div
                            className="button d-flex flex-row justify-content-between"
                            onClick={() => onButton()}
                        >
                            <span>
                                {shownDropdownValue}
                            </span>
                            {open ? (
                                <span className="ms-2">
                                    <i className="bi bi-chevron-up chevron-up-arrow"></i>
                                </span>
                            ) : (
                                <span className="ms-2">
                                    <i className="bi bi-chevron-down chevron-down-arrow"></i>
                                </span>
                            )}
                        </div>
                        {data?.length > 0 && open && (
                            <>
                                <div className={`content`}>
                                    {data.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div onClick={() => onElementClicked(item)}>
                                                    {item.name}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                {/* </div> */}
            </div>
        </>
    );
};
